import { MutationTree } from 'vuex';
import { StoreState } from '@/store/interfaces';

export const mutations: MutationTree<StoreState> = {
  set_page_language(state, pageLanguage) {
    state.page_language = pageLanguage;
  },
};
